<template>
    <!-- Added ref for the IntersectionObserver -->
    <div v-if="json" ref="twitchBlock" class="twitch-block">
        <div
            class="bgimg parallax-hook"
            :style="`background-image:url('${window.config.json.artifacts.twitchBg}')`"
        ></div>
        <div class="capper">
            <div class="capper-padded-2x">
                <div class="twitch-lr">
                    <div class="label label1 show-mobile flex" data-aos="fade-up">
                          <span class="icon">
                              <TwitchIcon class="icon-svg"/>
                          </span>
                        <span class="txt">{{ json.twitchTitle }}</span>
                    </div>

                    <div id="twitch-player-outer" data-aos="fade-up" >
                        <div v-show="currentVideoType === 'clip'" id="twitch-player-clip" v-html="clipIframeCode"></div>
                        <div v-show="currentVideoType !== 'clip'" :key="playerKey" id="twitch-player" data-aos="fade-up" style="position: relative;">
                            <!-- Overlay to detect user clicks on the player -->
                            <div
                                v-if="!userClickedOnce"
                                class="player-overlay"
                                @click="handlePlayerOverlayClick"
                                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 10; cursor: pointer;"
                            ></div>
                        </div>
                    </div>

                    <div class="twitch-links">
                        <div class="label label2 show-desktop flex" data-aos="fade-up">
                          <span class="icon">
                            <TwitchIcon class="icon-svg"/>
                          </span>
                            <span class="txt">{{ json.twitchTitle }}</span>
                        </div>
                        <Lines type="blank"/>
                        <div class="links">
                            <div
                                v-for="(item, index) in json.twitchLinks"
                                :key="`twitch${index}`"
                                class="link"
                                :class="{ active: activeIndex === index }"
                                @click="loadTwitch(item.twitchId, item.videoType, index)"
                                data-aos="custom-fade-in"
                            >
                                <span class="arrow">
                                    <ArrowRight/>
                                </span>
                                <span class="txt">{{ item.title }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Lines from "@/components/pieces/Lines.vue";
import TwitchIcon from "@/components/svgs/Twitch.vue";
import ArrowRight from "@/components/svgs/ArrowRight.vue";

export default {
    name: "TwitchBlock",
    components: {ArrowRight, TwitchIcon, Lines},
    props: {
        json: {
            type: Object,
            required: true,
        },
        isHomePage: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            window: window,
            player: null,
            activeIndex: 0,
            playerKey: 0, // Key for forced re-render
            userClickedOnce: false, // Track if user clicked play at least once
            observer: null,       // Intersection observer instance
            currentVideoType: 'video',
            clipIframeCode: ''
        };
    },
    mounted() {
        if (this.json?.twitchLinks?.length > 0) {
            // Create initial player without autoplay
            this.createPlayer(this.json.twitchLinks[0].twitchId,this.json.twitchLinks[0].videoType, false);
        }
        this.setupIntersectionObserver();
    },
    beforeUnmount() {
        // Clean up the observer when the component is destroyed
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    methods: {
        createPlayer(twitchId, videoType, autoplay = true) {
            if (this.player) {
                this.player.pause();
                this.player = null;
            }
            // Increment playerKey to force the DOM node to be recreated
            this.playerKey += 1;
            // Wait for the DOM to update before recreating the player
            this.$nextTick(() => {
                if (window.Twitch) {
                    this.currentVideoType = videoType
                    if (videoType === 'clip') {
                        const host = this.window.location.host
                        this.clipIframeCode = `<iframe title="Twitch Player" src="https://clips.twitch.tv/embed?clip=${twitchId}&parent=${host}" allowFullScreen="true" ></iframe>`
                    } else {
                        this.player = new window.Twitch.Player("twitch-player", {
                            video: twitchId,
                            autoplay: autoplay,
                            muted: false,
                        });
                        this.clipIframeCode = ''
                    }

                }

            });
        },
        loadTwitch(twitchId, videoType, index) {
            this.activeIndex = index;
            // Mark that the user has clicked play at least once (via the link)
            this.userClickedOnce = true;
            // Create (or recreate) the player with autoplay enabled
            this.createPlayer(twitchId, videoType, true);
        },
        handlePlayerOverlayClick() {
            // This method is called when the overlay is clicked.
            // Mark that the user has interacted with the player.
            this.userClickedOnce = true;
        },
        setupIntersectionObserver() {
            this.observer = new IntersectionObserver(
                ([entry]) => {
                    // Only act if the player exists and the user has interacted
                    if (!this.player || !this.userClickedOnce) return;

                    if (entry.intersectionRatio >= 0.5) {
                        // If at least 50% visible, resume playback
                        this.player.play();
                    } else {
                        // If less than 50% visible, pause the video
                        this.player.pause();
                    }
                },
                {threshold: [0.5]}
            );
            if (this.$refs.twitchBlock) {
                this.observer.observe(this.$refs.twitchBlock);
            }
        },
    },
};
</script>
